import { State } from 'app/redux';

export const getClassesAll = (state: State) => state.classes.classes;

export const getClasses = (state: State) => getClassesAll(state).items;

export const getSearches = (state: State) => state.classes.searches;
